import React, { Component } from 'react'

import ContMessageI18N from '../../containers/ContMessageI18N';
import TextWithFieldname from '../texts/TextWithFieldname';
import TeaserPres from './TeaserPres';
import Dico from '../../helpers/Dico';
import HelperTeaser from '../../helpers/HelperTeaser';
import ContCalculatorButton from '../../containers/ContCalculatorButton';
import HelperGenerics from '../../helpers/HelperGenerics';
import IconRender from '../std/IconRender';

class Teaser extends Component {
	handleBBCode(text) {
		if (text.includes('[b]') && text.includes('[/b]')) {
			var newtext = text.replace('[b]', '');
			newtext = newtext.replace('[/b]', '');
			return <strong>{newtext}</strong>;
		} else {
			return text;
		}
	}

	getMessage(i18nKey) { return <ContMessageI18N i18n={i18nKey} /> }

	occRenvoiGlob = 0;
	render() {
		const isWidget = this.props.teaser && this.props.teaser.callToAction.useWidget && this.props.teaser.callToAction.text;
		this.occRenvoiGlob = this.props.occRenvoi - HelperTeaser.getNbOccRenvoi(this.props.teaser) + 1;
		if (this.props.teaser != null) {
			this.props.teaser.textConditions != null && this.props.teaser.textConditions.regularPaymentConditions != null && this.returnReference();
			if (this.props.teaser.primarytext != null) {
				this.props.teaser.primarytext.map(() => {
					this.props.teaser.textConditions != null && this.props.teaser.textConditions.primaryTextConditions != null && this.returnReference();
					return null;
				})
			}

		}
		return (
			<React.Fragment>
				{(this.props.teaser || (this.props.responseObject && this.props.responseObject.hasError)) && <div className="row shadow rounded m-1">
					<TeaserPres
						vehicle={this.props.vehicle}
						settings={this.props.settings}
						teaser={this.props.teaser}
						context={this.props.context}
						vehicleDetails={this.props.vehicleDetails}
						env={this.props.env}
						occRenvoi={this.props.occRenvoi}
						disclaimer={this.props.disclaimer}
						responseObject={this.props.responseObject}
					/>
					{this.props.teaser && this.props.teaser.callToAction != null &&
						<TextWithFieldname fieldname="callToAction" developperView={this.props.settings.isDevelopperView}>
							{this.props.teaser.callToAction.href && this.props.teaser.callToAction.text &&
								HelperGenerics.renderLink(this.props.teaser.callToAction.href, null,
									this.handleBBCode(this.props.teaser.callToAction.text), 'btn btn-outline-primary')
							}
							{isWidget &&
								<button className='btn btn-outline-primary' onClick={() => { this.props.onWidgetOpen(); }} target="_blank">
									{this.handleBBCode(this.props.teaser.callToAction.text)}
								</button>
							}
							{isWidget && this.props.settings.widgetType.startsWith('WIDSFS') && this.props.settings.isDevelopperView
								&& <button className="btn btn-light" onClick={() => { this.props.reloadWidget() }} >
									<IconRender name="arrow-repeat" />
								</button>}
						</TextWithFieldname>
					}
					{this.props.teaser && this.props.teaser.textConditions != null && this.props.teaser.textConditions.ctaTeaserText != null &&
						<TextWithFieldname fieldname="ctaTeaserText" developperView={this.props.settings.isDevelopperView}>
							{this.props.teaser.textConditions.ctaTeaserText.map((line, index) => (
								<span key={index} style={{ ...Dico.getStyle(line.style, false), display: 'block' }}>
									{Dico.getTextWithArguments(line,
										this.props.teaser.data,
										this.props?.teaser?.data?.renderAmountNature ?? "TC", this.props.context.countryCode, this.props.context.languageCode,
										this.props.teaser.guide)}
									{line.conditionRef != null &&
										<React.Fragment > ({this.returnReference()})</React.Fragment>
									}
								</span>
							))}
						</TextWithFieldname>
					}
					{this.props.settings.isTestCalculator
						&&
						<ContCalculatorButton />
					}
				</div>}
			</React.Fragment>
		)
	}
	returnReference() {
		const occRenvoiIni = this.occRenvoiGlob;
		this.occRenvoiGlob++;
		return occRenvoiIni;
	}
}


export default (Teaser)

